import React from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import PropTypes from "prop-types";

export default function CAIHButtonLink({ label, href, children }) {
  return (
    <Link
      type="button"
      href={href}
      sx={theme => ({
        ...theme.components.MuiButton.styleOverrides.root,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "cobalt.bleuDigital100",
        p: 2,
        color: "cobalt.white",
        textDecoration: "none",
        ":hover, :focus": {
          backgroundColor: "cobalt.hover",
          color: "cobalt.white",
        },
        [theme.breakpoints.down("md")]: {
          width: "100%",
        },
      })}
    >
      {label}
      <Grid
        component="span"
        sx={{
          height: theme => theme.spacing(2),
          marginLeft: theme => theme.spacing(1),
        }}
      >
        {children}
      </Grid>
    </Link>
  );
}

CAIHButtonLink.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
